<template>
    <div v-show="carregado">
        <topo
            :app="app"
        />
        <banner
            :app="app"
        />
        <sobre
            :app="app"
        />
        <informacoes
            :app="app"
        />
        <funcionalidades
            :app="app"
        />
        <parceiros
            :app="app"
        />
        <planos
            v-if="app.ocultar_planos == '0'"
            :app="app"
            :grupoPlano="dados.grupoPlano"
            :planos="dados.planos"
        />
        <testemunhos
            :app="app"
            :depoimentos="dados.depoimentos"
        />
        <rodape
            :app="app"
        />
        <div
            v-html="css"
        />
    </div>
</template>
<script>
import Topo from './Topo'
import Banner from './Banner'
import Sobre from './Sobre'
import Informacoes from './Informacoes'
import Funcionalidades from './Funcionalidades'
import Parceiros from './Parceiros'
import Planos from './Planos'
import Testemunhos from './Testemunhos'
import Rodape from './Rodape'
import { baseURL} from '@/shared/services/config'
export default {
    components: {
        Topo,
        Banner,
        Sobre,
        Informacoes,
        Funcionalidades,
        Parceiros,
        Planos,
        Testemunhos,
        Rodape,
    },
    props: {
        app: { type: Object },
        dados: { type: Object },
    },
    data() {
        return {
            carregado: false,
        }
    },
    computed: {
        css: function(){
            let css = ''
            css += '<style>'
            
                css += '.mobile-menu .mean-bar {'
                    css += 'background: url("'+this.app.caminho_logomarca+'") no-repeat scroll left top;'
                    css += 'background-size: 230px 38px;'
                css += '}'

                css += '::-moz-selection {'
                    css += 'background: #' + this.app.cor_primaria + ';'
                css += '}'

                css += '::-moz-selection {'
                    css += 'background: #' + this.app.cor_primaria + ';'
                css += '}'

                css += '::selection {'
                    css += 'background: #' + this.app.cor_primaria + ';'
                css += '}'

                css += 'body {'
                    css += 'color: #' + this.app.cor_primaria + ';'
                css += '}'

                css += '#main-menu.stick {'
                    css += 'background: #' + this.app.cor_primaria + ' none repeat scroll 0 0;'
                css += '}'

                css += '.banner-area {'
                    css += 'background-color: #' + this.app.cor_primaria + ';'
                css += '}'

                css += '.button-default {'
                    css += 'color: #' + this.app.cor_primaria + ';'
                css += '}'

                css += '.button-default:hover {'
                    css += 'color: #' + this.app.cor_primaria + ' !important;'
                css += '}'

                css += '.single-item:hover .single-item-icon {'
                    css += 'background-color: #' + this.app.cor_primaria + ''
                css += '}'

                css += '.download-bg, .footer-bg {'
                    css += 'background: #' + this.app.cor_primaria + ' none repeat scroll 0 0;'
                css += '}'

                css += '.price-list li {'
                    css += 'color: #' + this.app.cor_primaria + ';'
                css += '}'

                css += '.price-btn .button {'
                    css += 'background: #' + this.app.cor_primaria + ' none repeat scroll 0 0;'
                css += '}'

                css += '.pricing-area .periodo-planos li{'
                    css += 'border: #' + this.app.cor_primaria + ' solid 1px;'
                css += '}'

                css += '.pricing-area .periodo-planos li:hover, .pricing-area .periodo-planos li.active{'
                    css += 'background: #' + this.app.cor_primaria + ';'
                css += '}'

                css += '.slick-prev:before, .slick-next:before {'
                    css += 'color: #' + this.app.cor_primaria + ';'
                css += '}'

                css += '.submit-form .button:hover, .footer-blue .submit-form .button:hover, .footer-yellow .submit-form .button:hover {'
                    css += 'color: #' + this.app.cor_primaria + ';'
                css += '}'

                css += '.single-contact-info:hover .contact-icon {'
                    css += 'background-color: #fff; color: #' + this.app.cor_primaria + ''
                css += '}'

                css += '.newsletter-content .button {'
                    css += 'color: #' + this.app.cor_primaria + ';'
                css += '}'

                css += '.banner-area.banner-image:after {'
                    css += 'background-color: #' + this.app.cor_primaria + ';'
                css += '}'

                css += '#text-search {'
                    css += 'color: #' + this.app.cor_primaria + ';'
                css += '}'

                css += '#btn-search-category:hover {'
                    css += 'background: #' + this.app.cor_primaria + ';'
                css += '}'

                css += '.category-items {'
                    css += 'color: #' + this.app.cor_primaria + ';'
                css += '}'

                css += '.pricing-four .price-btn .button-olive:hover {'
                    css += 'background: #' + this.app.cor_primaria + ' none repeat scroll 0 0 !important;'
                css += '}'

                css += '.footer-solid-color {'
                    css += 'background: #' + this.app.cor_primaria + ';'
                css += '}'

                css += '#scrollUp {'
                    css += 'background: #' + this.app.cor_primaria + ' none repeat scroll 0 0;'
                    css += 'border: 1px solid #' + this.app.cor_primaria + ''
                css += '}'

                css += '#scrollUp:hover {'
                    css += 'background-color: #fff; color: #' + this.app.cor_primaria + ''
                css += '}'

                
                css += '.pricing-olive .price-title {'
                    css += 'background: #' + this.app.cor_secundaria+ ';'
                css += '}'

                css += '.button-olive {'
                    css += 'background: #' + this.app.cor_secundaria+ ' !important; color: #fff !important'
                css += '}'

                css += '.olive-border {'
                    css += 'border: 1px solid #' + this.app.cor_secundaria+ ' !important;'
                css += '}'

                css += '.text-olive {'
                    css += 'color: #' + this.app.cor_secundaria+ ' !important'
                css += '}'

                css += '.section-title h1 span, .about-text h2 span {'
                    css += 'color: #' + this.app.cor_secundaria
                css += '}'

                css += '.main-menu nav ul li a:before {'
                    css += 'background: #' + this.app.cor_secundaria+ ' none repeat scroll 0 0;'
                css += '}'

                css += '.banner-text h1 span {'
                    css += 'color: #' + this.app.cor_secundaria+ ''
                css += '}'

                css += '.banner-buttons a.button-default:hover {'
                    css += 'background-color: #' + this.app.cor_secundaria+ ' !important;'
                css += '}'

                css += '.single-app {'
                    css += 'background: #' + this.app.cor_secundaria+ ' none repeat scroll 0 0;'
                css += '}'

                css += '.about-buttons button.button-default {'
                    css += 'border: 1px solid #' + this.app.cor_secundaria+ ';'
                css += '}'

                css += '.about-buttons a.button-default:hover {'
                    css += 'background-color:#' + this.app.cor_secundaria+ ' !important; color: #fff !important'
                css += '}'

                css += '.single-item-icon {'
                    css += 'background-color: #' + this.app.cor_secundaria+ ';'
                css += '}'

                css += '.download-btn:hover {'
                    css += 'background-color: #' + this.app.cor_secundaria+ ';'
                    css += 'border-color: #' + this.app.cor_secundaria+ ''
                css += '}'

                css += '.sin-testiImage img {'
                    css += 'border: 1px solid #' + this.app.cor_secundaria+ ';'
                css += '}'

                css += '.sin-testiImage.slick-current img {'
                    css += 'border: 3px solid #' + this.app.cor_secundaria+ ';'
                css += '}'

                css += '.slick-prev:hover:before, .slick-next:hover:before {'
                    css += 'color: #' + this.app.cor_secundaria+ ''
                css += '}'

                css += '.footer-area a:hover{'
                    css += 'color: #' + this.app.cor_secundaria+ ';'
                css += '}'

                css += '.submit-form .button {'
                    css += 'background-color: #' + this.app.cor_secundaria+ ';'
                css += '}'

                css += '.contact-icon {'
                    css += 'background-color: #' + this.app.cor_secundaria+ ';'
                css += '}'

                css += '.newsletter-content .button:hover {'
                    css += 'background-color: #' + this.app.cor_secundaria+ ';'
                css += '}'

                css += '.footer-links a:hover {'
                    css += 'background-color: #' + this.app.cor_secundaria+ ';'
                    css += 'border-color: #' + this.app.cor_secundaria+ ';'
                css += '}'

                css += '.footer-text span a:hover {'
                    css += 'border-bottom: 1px solid #' + this.app.cor_secundaria+ ';'
                    css += 'color: #' + this.app.cor_secundaria+ ';'
                css += '}'

                css += '.banner-buttons .button{'
                    css += 'background-color: #' + this.app.cor_secundaria+ ';'
                css += '}'

                css += '.service-info-container > span:after {'
                    css += 'color: #' + this.app.cor_secundaria+ ';'
                css += '}'

                css += '#btn-search-category {'
                    css += 'background: #' + this.app.cor_secundaria+ ' none repeat scroll 0 0;'
                css += '}'

                css += '.pricing-olive .price-title {'
                    css += 'background: #' + this.app.cor_secundaria+ ';'
                css += '}'

            css += '</style>'
            return css
        }
    },
    async mounted() {
        await this.carregaCss()
        await this.carregaScripts()
        setTimeout(() => {
            this.carregado = true
        }, 300)
    },
    methods: {
        carregaCss() {
            const css = [
                'https://fonts.googleapis.com/css?family=Raleway:400,800,700,600,500,300',
                '/layouts/site/css/bootstrap.min.css',
                '/layouts/site/css/font-awesome.min.css',
                '/layouts/site/css/whhg.css?versao=20170109',
                '/layouts/site/css/jquery.carousel-3d.default.css',
                '/layouts/site/css/slick.css',
                '/layouts/site/css/jquery-ui.css',
                '/layouts/site/css/meanmenu.min.css',
                '/layouts/site/css/animate.css',
                '/layouts/site/css/material-design-iconic-font.css',
                '/layouts/site/css/material-design-iconic-font.min.css',
                '/layouts/site/css/style.css',
                '/layouts/site/css/responsive.css',
            ]
            css.map((s) => {
                let link = document.createElement('link')
                link.setAttribute('rel', 'stylesheet')
                link.href = s
                document.head.appendChild(link)
            })
        },
        carregaScripts(){
            const scripts = [
                '/layouts/site/js/vendor/jquery-1.12.3.min.js',
                '/layouts/site/js/vendor/modernizr-2.8.3.min.js',
                '/layouts/site/js/jquery.validate.js',
                '/layouts/site/js/bootstrap.min.js',
                '/layouts/site/js/wow.min.js',
                '/layouts/site/js/jquery.meanmenu.js',
                '/layouts/site/js/jquery.scrollUp.min.js',
                '/layouts/site/js/slick.min.js',
                '/layouts/site/js/jquery.nav.js',
                '/layouts/site/js/jquery.resize.ex.js',
                '/layouts/site/js/waitforimages.js',
                '/layouts/site/js/jquery.carousel-3d.min.js',
                '/layouts/site/js/plugins.js',
                '/layouts/site/js/main.js',
            ]
            scripts.map((s, i) => {
                setTimeout(() => {
                    let script = document.createElement('script')
                    script.setAttribute('src', s)
                    document.body.appendChild(script)
                    script.setAttribute('baseURL', baseURL)
                }, i * 100)
            })
        },
    },
}
</script>